<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9996 15.613C13.5473 15.613 15.6125 13.5477 15.6125 11.0001C15.6125 8.45247 13.5473 6.38721 10.9996 6.38721C8.45199 6.38721 6.38672 8.45247 6.38672 11.0001C6.38672 13.5477 8.45199 15.613 10.9996 15.613Z" fill="white" />
  </svg>
</template>

<script>
export default {
  name: 'Radio',
};
</script>
